import React from "react";
import { Link } from "react-router-dom";
import { TagList } from "../tags/tags";
import styles from "./card.css";
import { Heading, Paragraph, SmallParagraph } from "../typography/typography";

export function defaultCard(info) {
	const { title, image, description, tags, id } = info;

	return (
		<Link to={`/bookmark/${id}`} className={styles.card}>
			{image ? (
				<div className={styles.image}>
					<img src={image} alt="" />
				</div>
			) : null}
			{image ? (
				<Paragraph className={styles.cardTitle}>{title}</Paragraph>
			) : (
				<Heading className={styles.cardTitleLarge}>{title}</Heading>
			)}

			{description ? (
				<SmallParagraph className={styles.cardDescription}>
					{description}
				</SmallParagraph>
			) : null}

			{tags ? <TagList tags={tags} /> : null}
		</Link>
	);
}



// WEBPACK FOOTER //
// ./src/components/ui/card/cardDefault.js